import React from "react";

/**
 * V2: SSR = optional add-ons (baggage/meal) selected on the fare card.
 * Here user only chooses: Include add-ons in booking OR Book base fare only (deselect SSR).
 * Baggage/meal selection happens on the fare card (OneWayFlightCard etc.), not here.
 */
const SSROptions = ({
  selectedSsr = {},
  setSelectedSsr,
  setShowSeatSelection,
  selectedFare,
}) => {
  const hasAddOnsSelected =
    selectedFare?.selectedBaggage ||
    selectedFare?.selectedMeal ||
    selectedFare?.selectedOnwardFare?.selectedBaggage ||
    selectedFare?.selectedOnwardFare?.selectedMeal ||
    selectedFare?.selectedOnwardFare?.ssrInfo?.baggageOption ||
    selectedFare?.selectedOnwardFare?.ssrInfo?.mealOption ||
    selectedFare?.selectedReturnFare?.selectedBaggage ||
    selectedFare?.selectedReturnFare?.selectedMeal ||
    selectedFare?.selectedReturnFare?.ssrInfo?.baggageOption ||
    selectedFare?.selectedReturnFare?.ssrInfo?.mealOption ||
    (Array.isArray(selectedFare?.ssrItems?.onward) && selectedFare.ssrItems.onward.length > 0) ||
    (Array.isArray(selectedFare?.ssrItems?.return) && selectedFare.ssrItems.return.length > 0);

  const selectWithSSR = () => {
    setSelectedSsr({ type: "with" });
    setShowSeatSelection(true);
  };

  const selectWithoutSSR = () => {
    setSelectedSsr({ type: "without" });
    setShowSeatSelection(false);
  };

  const isWith = selectedSsr?.type === "with";
  const isWithout = selectedSsr?.type === "without";

  return (
    <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm">
      <div className="mb-4">
        <h3 className="font-semibold text-gray-900 text-lg">
          Add-ons (SSR) – Include or exclude
        </h3>
        <p className="text-sm text-gray-500 mt-1">
          Baggage and meal were chosen on the fare step. Here you decide whether to include them in this booking or book base fare only.
        </p>
      </div>

      <div className="space-y-3">
        <button
          type="button"
          onClick={selectWithSSR}
          className={`w-full px-4 py-3 rounded-lg border-2 text-left font-medium transition-all ${
            isWith
              ? "border-green-600 bg-green-600 text-white"
              : "border-gray-300 bg-white text-gray-700 hover:border-green-400 hover:bg-green-50"
          }`}
        >
          Include add-ons (SSR)
        </button>
        <button
          type="button"
          onClick={selectWithoutSSR}
          className={`w-full px-4 py-3 rounded-lg border-2 text-left font-medium transition-all ${
            isWithout
              ? "border-blue-600 bg-blue-600 text-white"
              : "border-gray-300 bg-white text-gray-700 hover:border-blue-400 hover:bg-blue-50"
          }`}
        >
          Book without add-ons (base fare only)
        </button>
      </div>

      <div className="mt-3 text-sm text-gray-600">
        {hasAddOnsSelected && !isWith && (
          <p className="text-amber-700">
            You had selected baggage/meal on the fare; booking without add-ons will ignore them.
          </p>
        )}
        <p className="mt-1">
          <span className="font-medium">Current choice: </span>
          {isWith ? "Include add-ons" : isWithout ? "Base fare only" : "— Select one above"}
        </p>
      </div>
    </div>
  );
};

export default SSROptions;
